import MuiLoadingButton from '@mui/lab/LoadingButton'
import MuiDialog from '@mui/material/Dialog'
import MuiDialogActions from '@mui/material/DialogActions'
import MuiDialogContent from '@mui/material/DialogContent'
import MuiDialogContentText from '@mui/material/DialogContentText'
import MuiDialogTitle from '@mui/material/DialogTitle'
import { useDeleteSectionFromLayoutMutation } from '../../../slice'

const DeleteSection = ({ campaign, section, open, setOpen }) => {
  const [deleteSection, { isLoading }] = useDeleteSectionFromLayoutMutation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    await deleteSection({ campaignId: campaign.id, sectionId: section.id })
    setOpen(false)
  }

  return (
    <MuiDialog open={open} onClose={handleClose}>
      <MuiDialogTitle>{`Delete ${section?.name || 'this'} section?`}</MuiDialogTitle>
      <MuiDialogContent dividers>
        <MuiDialogContentText>
          Are you sure you want to delete this section from the campaign layout?
        </MuiDialogContentText>
      </MuiDialogContent>
      <MuiDialogActions>
        <MuiLoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
          Cancel
        </MuiLoadingButton>
        <MuiLoadingButton color="error" loading={isLoading} onClick={handleDelete}>
          Remove
        </MuiLoadingButton>
      </MuiDialogActions>
    </MuiDialog>
  )
}

export default DeleteSection
